import { FormControl, InputLabel, Select, MenuItem, Stack, FormHelperText } from "@mui/material";
import { RepeatPatternSchedulingStrategyModel, ActionModuleFrequency, isRepeatPatternSchedulingStrategyModel } from "../../../../types/actionModule/schedulingStrategy/schedulingStrategyType";
import { useTranslation } from "react-i18next";
import { SchedulingStrategyEditorProps } from "../../../../types/actionModule/editor/schedulingStrategyEditorTypes";


export default function RepeatPatternSchedulingStrategyEditor(props: SchedulingStrategyEditorProps) {
    const { t } = useTranslation();
    const value = props.value;

    if(!isRepeatPatternSchedulingStrategyModel(value)) {
        return <>Invalid value</>;
    }

    return <Stack direction="column" sx={{gap: 2}}>
        <FormControl>
            <InputLabel>{t("actionModules.schedulingStrategy.repeatPattern.frequency")}</InputLabel>
            <Select
                label={t("actionModules.schedulingStrategy.repeatPattern.frequency")}
                value={value.frequency}
                size="small"
                onChange={(v) => props.onChanged({
                    ...value,
                    frequency: v.target.value
                } as RepeatPatternSchedulingStrategyModel)}
            >
                <MenuItem value={ActionModuleFrequency.Daily}>{t("actionModules.schedulingStrategy.repeatPattern.daily")}</MenuItem>
                <MenuItem value={ActionModuleFrequency.Weekly}>{t("actionModules.schedulingStrategy.repeatPattern.weekly")}</MenuItem>
                <MenuItem value={ActionModuleFrequency.Monthly}>{t("actionModules.schedulingStrategy.repeatPattern.monthly")}</MenuItem>
                <MenuItem value={ActionModuleFrequency.Yearly}>{t("actionModules.schedulingStrategy.repeatPattern.yearly")}</MenuItem>
            </Select>
            <FormHelperText>
                {t("actionModules.schedulingStrategy.repeatPattern.description")}
            </FormHelperText>
        </FormControl>
    </Stack>
}